export default {
  myBets: [],
  topWins: [],
  isProcess: false,
}